<template>
<div class="sidebar-root">
  <!-- 移动端汉堡按钮 -->
  <button class="mobile-hamburger" v-if="!mobileOpen" @click="mobileOpen = true">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
  </button>
  <!-- 移动端遮罩 -->
  <div class="mobile-overlay" v-if="mobileOpen" @click="mobileOpen = false"></div>
  <!-- 移动端关闭按钮 -->
  <button class="mobile-close-btn" v-if="mobileOpen" @click="mobileOpen = false">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
  </button>
  <aside class="new-sidebar" :class="{ 'mobile-open': mobileOpen }">
    <div class="sidebar-inner">
      <!-- Logo -->
      <router-link :to="navTo('Home')" class="sidebar-logo">
        <img src="@/assets/images/Miral.webp" alt="Miral" width="480" height="480" class="sidebar-logo-img" />
      </router-link>

      <!-- 导航 -->
      <nav class="sidebar-nav">
        <router-link :to="navTo('Home')" class="sidebar-item" :class="{ active: activeNav === 'home' }" @click.native="mobileOpen = false">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          <span class="sidebar-item-label">{{ $t('nav.home') }}</span>
        </router-link>
        <router-link :to="imageLink" class="sidebar-item" :class="{ active: activeNav === 'image' }" @click.native="mobileOpen = false">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
          <span class="sidebar-item-label">{{ $t('footer.aiImages') }}</span>
        </router-link>
        <router-link :to="videoLink" class="sidebar-item" :class="{ active: activeNav === 'video' }" @click.native="mobileOpen = false">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
          <span class="sidebar-item-label">{{ $t('footer.aiVideos') }}</span>
        </router-link>
        <router-link :to="navTo('Music')" class="sidebar-item" :class="{ active: activeNav === 'music' }" @click.native="mobileOpen = false">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
          <span class="sidebar-item-label">{{ $t('footer.aiMusic') }}</span>
        </router-link>
        <router-link :to="navTo('AppsPage')" class="sidebar-item" :class="{ active: activeNav === 'apps' }" @click.native="mobileOpen = false">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
          <span class="sidebar-item-label">{{ $t('footer.apps') }}</span>
        </router-link>
        <router-link :to="navTo('Tools')" class="sidebar-item" :class="{ active: activeNav === 'tools' }" @click.native="mobileOpen = false">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
          <span class="sidebar-item-label">{{ $t('footer.tools') }}</span>
        </router-link>
      </nav>

      <!-- 底部操作区 -->
      <div class="sidebar-bottom">
        <!-- 升级按钮 -->
        <router-link :to="navTo('Pricing')" :class="['sidebar-action-btn', 'sidebar-upgrade-btn', { active: isPricingActive }]" :title="$t('nav.signup')" @click.native="mobileOpen = false">
          <svg width="18" height="18" viewBox="0 0 24 24" :fill="isPricingActive ? 'currentColor' : 'none'" :stroke="isPricingActive ? 'none' : 'currentColor'" stroke-width="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
        </router-link>
        <!-- 语言切换 -->
        <button class="sidebar-action-btn" @click="showLangModal = true" :title="currentLangLabel">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
        </button>
        <!-- 用户/登录：按钮样式固定，登录前后不切换 -->
        <div class="sidebar-user-wrapper">
          <button class="sidebar-action-btn sidebar-login-btn" @click="handleUserActionClick" :title="isLoggedIn ? $t('nav.profile') : $t('nav.login')">
            <svg class="sidebar-login-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28" fill="none">
              <path d="M19.822 10.5013C19.822 13.7229 17.2065 16.3346 13.9802 16.3346C10.7542 16.3346 8.13867 13.7229 8.13867 10.5013C8.13867 7.27965 10.7542 4.66797 13.9802 4.66797C17.2065 4.66797 19.822 7.27965 19.822 10.5013Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M3.5 23.332C7.58333 25.082 10.7454 25.6654 14 25.6654C17.8419 25.6654 21.5833 24.4987 24.5 23.332" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="sidebar-user-dropdown" v-if="isLoggedIn" v-show="showUserDropdown" @click.stop>
              <div class="dropdown-user-info">{{ currentUser && currentUser.email }}</div>
              <router-link :to="navTo('Profile')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {{ $t('nav.profile') }}
              </router-link>
              <router-link :to="navTo('Gallery')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                {{ $t('nav.myWorks') }}
              </router-link>
              <!-- 帮助 - 悬停展开子菜单 -->
              <div class="dropdown-help-wrapper">
                <div class="dropdown-user-item help-trigger">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                  {{ $t('nav.help') }}
                  <svg class="help-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
                <div class="dropdown-help-submenu">
                  <router-link :to="navTo('Models')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                    {{ $t('footer.allModels') }}
                  </router-link>
                  <router-link :to="navTo('Pricing')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                    {{ $t('footer.pricing') }}
                  </router-link>
                  <router-link :to="navTo('TrustSafety')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                    {{ $t('footer.trustSafety') }}
                  </router-link>
                  <router-link :to="navTo('Terms')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                    {{ $t('footer.terms') }}
                  </router-link>
                  <router-link :to="navTo('Privacy')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                    {{ $t('footer.privacy') }}
                  </router-link>
                  <router-link :to="navTo('FAQ')" class="dropdown-user-item" @click.native="showUserDropdown=false">
                    {{ $t('footer.faq') }}
                  </router-link>
                </div>
              </div>
              <button class="dropdown-user-item logout-item" @click="handleLogout">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                {{ $t('nav.logout') }}
              </button>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- 语言弹窗 -->
  <div class="modal-overlay" v-if="showLangModal" @click.self="showLangModal=false">
    <div class="lang-modal-content">
      <div class="lang-modal-header">
        <h3>{{ $t('langModal.title') }}</h3>
        <button class="modal-close" @click="showLangModal=false">&times;</button>
      </div>
      <div class="lang-grid">
        <button v-for="lang in languages" :key="lang.code"
          :class="['lang-option', { active: currentLocale === lang.code }]"
          @click="selectLanguage(lang.code)">
          <span class="lang-flag">{{ lang.flag }}</span>
          <span class="lang-name">{{ lang.name }}</span>
          <svg v-if="currentLocale === lang.code" class="lang-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
        </button>
      </div>
    </div>
  </div>

  <!-- 登录弹窗 -->
  <div class="modal-overlay" v-if="$store.state.showLoginModal" @click.self="$store.dispatch('hideLoginModal')">
    <div class="login-modal-content">
      <button class="modal-close" @click="$store.dispatch('hideLoginModal')">&times;</button>
      <h2>{{ $t('nav.login') }} Miral</h2>
      <p class="text-muted" style="margin-bottom:24px;">{{ $t('nav.codeLoginHint') }}</p>
      <div class="login-form">
        <input type="email" v-model="loginForm.email" :placeholder="$t('nav.email')" class="form-input" :disabled="codeSent" />
        <template v-if="codeSent">
          <div class="code-input-wrapper">
            <input type="text" v-model="loginForm.code" :placeholder="$t('nav.verificationCode')" class="form-input" maxlength="6" />
            <button class="btn btn-outline resend-btn" @click="handleSendCode" :disabled="countdown > 0">
              {{ countdown > 0 ? countdown + 's' : $t('nav.resendCode') }}
            </button>
          </div>
          <p class="email-hint">{{ $t('nav.checkSpamFolder') }}</p>
        </template>
        <p v-if="authError" class="auth-error">{{ authError }}</p>
        <button class="btn btn-primary btn-lg" style="width:100%;justify-content:center;" @click="codeSent ? handleVerifyCode() : handleSendCode()" :disabled="authLoading">
          {{ authLoading ? $t('nav.processing') : (codeSent ? $t('nav.verifyAndLogin') : $t('nav.sendCode')) }}
        </button>
      </div>
      <template v-if="!codeSent">
        <div class="login-divider">
          <span>{{ $t('nav.orContinueWith') }}</span>
        </div>
        <div class="social-login">
          <div id="google-signin-btn"></div>
        </div>
      </template>
      <p class="login-terms-hint">
        {{ $t('nav.registerHint') }}
        <router-link :to="navTo('Privacy')" target="_blank">{{ $t('footer.privacy') }}</router-link>
        {{ $t('nav.and') }}
        <router-link :to="navTo('Terms')" target="_blank">{{ $t('footer.terms') }}</router-link>
      </p>
      <p class="login-free-credits">
        <strong>{{ $t('nav.freeCreditsLabel') }}</strong> {{ $t('nav.freeCreditsDesc') }}
      </p>
    </div>
  </div>
</div>
</template>

<script>
import { sendVerifyCode, login, googleLogin, logout, getCurrentUser, isAuthenticated } from '@/api/auth'
import GA from '@/utils/ga'

export default {
  name: 'AppSidebar',
  data: function () {
    return {
      /* 语言弹窗 */
      showLangModal: false,
      languages: [
        { code: 'zh', name: '简体中文', flag: '🇨🇳' },
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'ja', name: '日本語', flag: '🇯🇵' },
        { code: 'ko', name: '한국어', flag: '🇰🇷' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'es', name: 'Español', flag: '🇪🇸' },
        { code: 'it', name: 'Italiano', flag: '🇮🇹' },
        { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
        { code: 'pt', name: 'Português', flag: '🇧🇷' },
        { code: 'pl', name: 'Polski', flag: '🇵🇱' },
        { code: 'ar', name: 'العربية', flag: '🇸🇦' }
      ],
      /* 登录 */
      loginForm: { email: '', code: '' },
      codeSent: false,
      countdown: 0,
      countdownTimer: null,
      authError: null,
      authLoading: false,
      isLoggedIn: false,
      currentUser: null,
      /* 用户下拉 */
      showUserDropdown: false,
      /* 移动端菜单 */
      mobileOpen: false
    }
  },
  computed: {
    /* 当前高亮的导航项 */
    activeNav: function () {
      var name = this.$route.name
      var path = this.$route.path
      /* 去掉语言前缀 */
      var cleanPath = path.replace(/^\/(zh|en|ja|ko|fr|es|it|de|pt|pl|ar)(\/|$)/, '/')

      /* 首页 */
      if (name === 'Home' || cleanPath === '/') return 'home'

      /* AI 图片 SEO 落地页 */
      if (cleanPath.indexOf('/image-models/') > -1) return 'image'

      /* AI图片 / AI视频 - 统一 models 路径 */
      if (cleanPath.indexOf('/models/') > -1) {
        /* 判断是否是图片模型 */
        var modelId = cleanPath.split('/models/')[1]
        if (modelId) {
          var imageModels = ['flux-pro-1-1-ultra', 'flux-schnell', 'flux-2', 'flux-kontext', 'seedream-4', 'seedream-5', 'gpt-image-1', 'gpt-image-1-5', 'midjourney', 'nano-banana', 'nano-banana-2', 'qwen-image-2-0-pro', 'z-image-turbo', 'sd-3-5', 'stable-diffusion-3-5']
          if (imageModels.indexOf(modelId) > -1) return 'image'
          return 'video'
        }
      }

      /* 向后兼容：旧 /image-gen/ 和 /video-gen/ 路径 */
      if (cleanPath.indexOf('/image-gen/') > -1) return 'image'
      if (cleanPath.indexOf('/video-gen/') > -1) return 'video'

      /* AI音乐 */
      if (name === 'Music') return 'music'

      /* 工具 */
      if (name === 'Tools' || cleanPath.indexOf('/tools') > -1) return 'tools'

      /* Apps */
      if (cleanPath.indexOf('/apps') > -1) return 'apps'

      return ''
    },
    isPricingActive: function () {
      var name = this.$route.name
      var path = this.$route.path || ''
      var cleanPath = path.replace(/^\/(zh|en|ja|ko|fr|es|it|de|pt|pl|ar)(\/|$)/, '/')
      return name === 'Pricing' || cleanPath.indexOf('/pricing') === 0
    },
    imageLink: function () {
      var lang = this.$route.params.lang
      var path = '/models/seedream-5'
      return lang ? '/' + lang + path : path
    },
    videoLink: function () {
      var lang = this.$route.params.lang
      var path = '/models/wan-2-6'
      return lang ? '/' + lang + path : path
    },
    currentLocale: function () { return this.$i18n.locale },
    currentLangLabel: function () {
      var self = this
      var lang = this.languages.find(function (l) { return l.code === self.$i18n.locale })
      return lang ? lang.name : 'English'
    },
    userInitial: function () {
      if (this.currentUser && this.currentUser.uName) return this.currentUser.uName.charAt(0).toUpperCase()
      if (this.currentUser && this.currentUser.email) return this.currentUser.email.charAt(0).toUpperCase()
      return 'U'
    }
  },
  watch: {
    '$store.state.showLoginModal': function (val) {
      var self = this
      if (val) {
        self.$nextTick(function () {
          setTimeout(function () { self.handleGoogleLogin() }, 100)
        })
      } else {
        self.resetLoginForm()
      }
    }
  },
  mounted: function () {
    this.checkAuthStatus()
    document.addEventListener('click', this.closeUserDropdown)
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.closeUserDropdown)
  },
  methods: {
    navTo: function (name) {
      var lang = this.$route.params.lang
      return lang ? { name: name, params: { lang: lang } } : { name: name }
    },
    /* 语言切换 */
    selectLanguage: function (code) {
      this.$i18n.locale = code
      this.$store.dispatch('setLocale', code)
      this.showLangModal = false
      this.$root.$meta().refresh()
      var currentPath = this.$route.path
      var pathParts = currentPath.split('/').filter(function (p) { return p })
      var supportedLocales = ['zh', 'en', 'ja', 'ko', 'fr', 'es', 'it', 'de', 'pt', 'pl', 'ar']
      while (pathParts.length > 0 && supportedLocales.indexOf(pathParts[0]) !== -1) { pathParts.shift() }
      var contentPath = '/' + pathParts.join('/')
      if (code === 'en') {
        this.$router.push(contentPath || '/')
      } else {
        this.$router.push('/' + code + contentPath)
      }
    },
    /* 登录 */
    handleLoginClick: function () {
      GA.loginClick()
      this.$store.dispatch('showLoginModal')
    },
    handleUserActionClick: function () {
      if (this.isLoggedIn) {
        this.showUserDropdown = !this.showUserDropdown
        return
      }
      this.handleLoginClick()
    },
    resetLoginForm: function () {
      this.loginForm = { email: '', code: '' }
      this.codeSent = false
      this.authError = null
      if (this.countdownTimer) { clearInterval(this.countdownTimer); this.countdownTimer = null }
      this.countdown = 0
    },
    startCountdown: function () {
      var self = this
      self.countdown = 60
      self.countdownTimer = setInterval(function () {
        self.countdown--
        if (self.countdown <= 0) { clearInterval(self.countdownTimer); self.countdownTimer = null }
      }, 1000)
    },
    handleSendCode: function () {
      var self = this
      if (!this.loginForm.email) { this.authError = this.$t('nav.enterEmail'); return }
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.loginForm.email)) { this.authError = this.$t('nav.invalidEmail'); return }
      this.authLoading = true; this.authError = null
      sendVerifyCode(this.loginForm.email).then(function (response) {
        if (response && response.code === 200) { self.codeSent = true; self.startCountdown() }
        else { self.authError = self.$t('nav.sendCodeFailed') }
      }).catch(function (error) { self.authError = error.message || self.$t('nav.sendCodeFailed') })
      .finally(function () { self.authLoading = false })
    },
    handleVerifyCode: function () {
      var self = this
      if (!this.loginForm.code || this.loginForm.code.length !== 6) { this.authError = this.$t('nav.enterValidCode'); return }
      this.authLoading = true; this.authError = null
      login(this.loginForm.email, this.loginForm.code).then(function (response) {
        if (response.success) {
          self.isLoggedIn = true; self.currentUser = response.user
          self.$store.commit('SET_USER_INFO', response.user)
          self.$store.dispatch('hideLoginModal'); self.resetLoginForm()
          GA.loginSuccess(response.user.id, 'email')
        } else { self.authError = self.$t('nav.verifyCodeFailed') }
      }).catch(function (error) { self.authError = error.message || self.$t('nav.verifyCodeFailed') })
      .finally(function () { self.authLoading = false })
    },
    handleLogout: function () {
      var self = this
      logout().then(function () { self.isLoggedIn = false; self.currentUser = null; self.$store.commit('SET_USER_INFO', null) })
      .catch(function () { self.isLoggedIn = false; self.currentUser = null; self.$store.commit('SET_USER_INFO', null) })
    },
    checkAuthStatus: function () {
      var self = this
      if (isAuthenticated()) {
        getCurrentUser().then(function (response) {
          if (response && response.success) { self.isLoggedIn = true; self.currentUser = response.user; self.$store.commit('SET_USER_INFO', response.user) }
          else { self.isLoggedIn = false; self.currentUser = null; self.$store.commit('SET_USER_INFO', null) }
        }).catch(function () { self.isLoggedIn = false; self.currentUser = null; self.$store.commit('SET_USER_INFO', null) })
      }
    },
    closeUserDropdown: function (e) {
      if (!e.target.closest('.sidebar-user-wrapper')) { this.showUserDropdown = false }
    },
    /* Google 登录 */
    handleGoogleLogin: function () {
      var self = this
      if (!window.google || !window.google.accounts) { self.authError = self.$t('nav.googleNotLoaded'); return }
      self.authError = null
      try {
        window.google.accounts.id.initialize({
          client_id: '681202568731-s0p015ii4r4o47om5kv4mbhf6c79upv2.apps.googleusercontent.com',
          callback: function (response) { self.handleGoogleCallback(response) }
        })
        var btn = document.getElementById('google-signin-btn')
        if (btn) {
          btn.innerHTML = ''
          window.google.accounts.id.renderButton(btn, { theme: 'outline', size: 'large', width: btn.offsetWidth || 280, text: 'signin_with', shape: 'rectangular' })
        }
      } catch (error) { self.authError = self.$t('nav.googleInitFailed') }
    },
    handleGoogleCallback: function (response) {
      var self = this
      if (response.credential) {
        var payload = self.parseJwt(response.credential)
        if (payload && payload.email) {
          self.authLoading = true
          googleLogin(payload.email, payload.picture || '', payload.name || payload.email.split('@')[0]).then(function (res) {
            if (res && res.success) {
              self.isLoggedIn = true; self.currentUser = res.user
              self.$store.commit('SET_USER_INFO', res.user)
              self.$store.dispatch('hideLoginModal'); GA.loginSuccess(res.user.id, 'google')
            } else { self.authError = self.$t('nav.googleLoginFailed') }
          }).catch(function (error) { self.authError = error.message || self.$t('nav.googleLoginFailed') })
          .finally(function () { self.authLoading = false })
        } else { self.authError = self.$t('nav.googleUserInfoFailed'); self.authLoading = false }
      } else { self.authError = self.$t('nav.googleCancelled'); self.authLoading = false }
    },
    parseJwt: function (token) {
      try {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2) }).join(''))
        return JSON.parse(jsonPayload)
      } catch (e) { return null }
    }
  }
}
</script>

<style scoped>
.new-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 72px;
  background: var(--bg-sidebar, #f8f9fa);
  border-right: 1px solid var(--border-sidebar, #e5e7eb);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transition: background 0.3s, border-color 0.3s;
}

.sidebar-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
}

/* Logo */
.sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}
.sidebar-logo-img {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md, 10px);
}

/* 导航 */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-md, 10px);
  color: var(--text-sidebar, #6b7280);
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;
  padding: 4px;
}
.sidebar-item:hover {
  background: var(--bg-sidebar-hover, rgba(0, 0, 0, 0.04));
  color: var(--text-sidebar-hover, #111827);
}
.sidebar-item.active {
  background: var(--bg-sidebar-active, rgba(5, 150, 105, 0.1));
  color: var(--accent, #059669);
}
.sidebar-item-label {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 48px;
}

/* 底部操作区 */
.sidebar-bottom {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-top: 12px;
  border-top: 1px solid var(--border-sidebar, #e5e7eb);
  width: 56px;
}

.sidebar-action-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md, 10px);
  color: var(--text-sidebar, #6b7280);
  cursor: pointer;
  transition: all 0.2s;
  background: none;
  border: none;
  text-decoration: none;
}
.sidebar-action-btn:hover {
  background: var(--bg-sidebar-hover, rgba(0, 0, 0, 0.04));
  color: var(--text-sidebar-hover, #111827);
}

.sidebar-upgrade-btn {
  color: var(--accent, #059669);
}
.sidebar-upgrade-btn:hover {
  background: var(--bg-sidebar-active, rgba(5, 150, 105, 0.1));
}
.sidebar-upgrade-btn.active {
  background: var(--bg-sidebar-active, rgba(5, 150, 105, 0.1));
  color: var(--accent, #059669);
}

/* 用户头像 */
.sidebar-user-wrapper { position: relative; }
.sidebar-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent, #059669);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
}
.sidebar-avatar img { width: 100%; height: 100%; object-fit: cover; }
.sidebar-user-btn { padding: 4px; }

/* 用户下拉菜单 */
.sidebar-user-dropdown {
  position: absolute;
  bottom: 100%;
  left: 100%;
  margin-left: 8px;
  margin-bottom: 0;
  min-width: 180px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius-lg, 16px);
  padding: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  animation: slideUp 0.2s ease;
  z-index: 1100;
}
.dropdown-user-info {
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 4px;
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown-user-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--radius-sm, 6px);
  font-size: 13px;
  color: #374151;
  text-decoration: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: none;
  border: none;
}
.dropdown-user-item:hover { background: #f3f4f6; color: #111827; }
.logout-item:hover { color: #ef4444 !important; }
.sidebar-login-btn {
  color: #1f2937;
}
.sidebar-login-btn:hover {
  color: #0f172a;
}
.sidebar-login-btn .sidebar-login-icon {
  transition: transform 0.3s ease-in-out;
}
.sidebar-login-btn:hover .sidebar-login-icon {
  transform: scale(1.2);
}

/* 帮助悬停子菜单 */
.dropdown-help-wrapper { position: relative; }
.help-trigger { cursor: default; justify-content: flex-start; }
.help-arrow { margin-left: auto; opacity: 0.4; }
.dropdown-help-submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  margin-left: 0;
  padding-left: 4px;
  min-width: 160px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius-lg, 16px);
  padding: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  z-index: 1200;
}
.dropdown-help-wrapper:hover .dropdown-help-submenu { display: block; }
.dropdown-help-submenu .dropdown-user-item {
  padding: 8px 12px;
  font-size: 12px;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 弹窗样式在 unscoped 块中 */

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ── 移动端汉堡菜单 ──────────────────────── */
.mobile-hamburger {
  display: none;
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1100;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #374151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.mobile-hamburger:hover {
  background: #f9fafb;
}
.mobile-overlay {
  display: none;
}
.mobile-close-btn {
  display: none;
  position: fixed;
  top: 14px;
  left: 80px;
  z-index: 1200;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

@media (max-width: 1024px) {
  .mobile-hamburger {
    display: flex;
  }
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
  }
  .new-sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 1100;
  }
  .new-sidebar.mobile-open {
    transform: translateX(0);
  }
  .mobile-close-btn {
    display: flex;
  }
  .mobile-close-btn:hover {
    color: #374151;
    background: #f9fafb;
  }
}
</style>

<style>
/* 弹窗样式（unscoped，确保 fixed 定位不受 scoped 层叠上下文影响） */
.sidebar-root .modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: sidebarFadeIn 0.2s ease;
}
.sidebar-root .modal-close {
  position: absolute;
  top: 16px; right: 16px;
  font-size: 24px;
  color: #9ca3af;
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  background: none;
  border: none;
}
.sidebar-root .modal-close:hover { background: rgba(0,0,0,0.05); }

.sidebar-root .lang-modal-content {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  padding: 32px;
  width: 520px;
  max-width: 90vw;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}
.sidebar-root .lang-modal-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px; }
.sidebar-root .lang-modal-header h3 { font-size: 20px; font-weight: 700; color: #111827; }
.sidebar-root .lang-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
.sidebar-root .lang-option {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  color: #374151;
}
.sidebar-root .lang-option:hover { background: #f9fafb; border-color: #9ca3af; }
.sidebar-root .lang-option.active { background: rgba(5,150,105,0.08); border-color: rgba(5,150,105,0.3); }
.sidebar-root .lang-flag { font-size: 20px; }
.sidebar-root .lang-name { font-size: 14px; flex: 1; color: #374151; }
.sidebar-root .lang-check { flex-shrink: 0; }

.sidebar-root .login-modal-content {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  padding: 40px;
  width: 420px;
  max-width: 90vw;
  position: relative;
  text-align: center;
  color: #111827;
}
.sidebar-root .login-modal-content h2 { color: #111827; }
.sidebar-root .login-form { display: flex; flex-direction: column; gap: 12px; }
.sidebar-root .code-input-wrapper { display: flex; gap: 8px; }
.sidebar-root .code-input-wrapper .form-input { flex: 1; letter-spacing: 4px; text-align: center; }
.sidebar-root .resend-btn {
  white-space: nowrap; padding: 0 16px; font-size: 13px;
  border-color: #d1d5db; color: #6b7280;
}
.sidebar-root .resend-btn:not(:disabled):hover { border-color: #059669; color: #059669; }
.sidebar-root .resend-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.sidebar-root .form-input {
  width: 100%; padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  color: #111827;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
}
.sidebar-root .form-input:focus { border-color: #059669; }
.sidebar-root .login-divider {
  display: flex; align-items: center; gap: 16px;
  margin: 20px 0; color: #9ca3af; font-size: 13px;
}
.sidebar-root .login-divider::before,
.sidebar-root .login-divider::after { content: ''; flex: 1; height: 1px; background: #e5e7eb; }
.sidebar-root .social-login { display: flex; flex-direction: column; gap: 12px; margin-top: 16px; }
.sidebar-root .auth-error { color: #ef4444; font-size: 13px; margin: 8px 0; text-align: left; }
.sidebar-root .email-hint { font-size: 12px; color: #9ca3af; margin: 2px 0 0; text-align: center; }
.sidebar-root .login-terms-hint { font-size: 12px; color: #9ca3af; margin-top: 16px; line-height: 1.5; }
.sidebar-root .login-terms-hint a { color: #059669; text-decoration: none; }
.sidebar-root .login-terms-hint a:hover { text-decoration: underline; }
.sidebar-root .login-free-credits { font-size: 13px; color: #f59e0b; margin-top: 12px; line-height: 1.5; }
.sidebar-root .login-free-credits strong { font-weight: 600; }

@keyframes sidebarFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 工具分类弹窗 */
.sidebar-root .tool-category-modal-content {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  padding: 32px;
  width: 400px;
  max-width: 90vw;
  position: relative;
}
.sidebar-root .tool-category-grid { display: flex; flex-direction: column; gap: 12px; }
.sidebar-root .tool-category-option {
  display: flex; align-items: center; gap: 14px;
  padding: 18px 20px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  color: #374151;
}
.sidebar-root .tool-category-option:hover { background: #f9fafb; border-color: var(--accent, #059669); }
.sidebar-root .tool-category-icon { font-size: 28px; flex-shrink: 0; }
.sidebar-root .tool-category-name { font-size: 16px; font-weight: 600; flex: 1; color: #111827; }
</style>
